import React from 'react';
import { Typography, Stack, Box, IconButton, SxProps, Theme } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TikTokIcon from './icons/TikTokIcon';
import SpotifyIcon from './icons/SpotifyIcon';

interface SourcePlatformProps {
    contentSource?: 'rss' | 'youtube'
    | 'instagram'
    | 'tiktok'
    | 'facebook'
    | 'spotify';
    showLabel?: boolean;
    iconSize?: number;
    url?: string;
    sx?: SxProps<Theme>;
}

const platformConfig = {
    'youtube': {
        icon: YouTubeIcon,
        label: 'YouTube',
        color: '#FF0000',
    },
    'instagram': {
        icon: InstagramIcon,
        label: 'Instagram',
        color: '#E4405F',
    },
    'tiktok': {
        icon: TikTokIcon,
        label: 'TikTok',
        color: '#000000',
    },
    'facebook': {
        icon: FacebookIcon,
        label: 'Facebook',
        color: '#1877F2',
    },
    'rss': {
        icon: FacebookIcon,
        label: 'RSS',
        color: '#000000',
    },
    'spotify': {
        icon: SpotifyIcon,
        label: 'Spotify',
        color: '#000',
    },
};

export const SourcePlatform: React.FC<SourcePlatformProps> = ({
    contentSource,
    showLabel = true,
    iconSize = 24,
    url,
    sx,
}) => {
    if (!contentSource) {
        return (
            <Stack direction="row" spacing={1} alignItems="center">
                <HelpOutlineIcon sx={{ fontSize: iconSize, color: 'text.secondary' }} />
                {showLabel && (
                    <Typography variant="body1" color="text.primary">
                        Unknown Platform
                    </Typography>
                )}
            </Stack>
        );
    }

    const config = platformConfig[contentSource];
    const Icon = config.icon;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
            <Icon sx={{ fontSize: iconSize, color: config.color }} />
            {showLabel && (
                <Typography
                    variant="body2"
                    sx={{ ml: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}
                >
                    {config.label}
                    {url && (
                        <IconButton
                            size="small"
                            sx={{ p: 0.5 }}
                            onClick={e => {
                                e.stopPropagation();
                                window.open(url, '_blank', 'noopener,noreferrer');
                            }}
                        >
                            <OpenInNewIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    )}
                </Typography>
            )}
        </Box>
    );
}; 